module.exports = __webpack_public_path__ + "img/vegetable-green-beans-190x100.1ed4c435.jpg";